const i18n = {
  'zh-CN': {
    networkAbnormalityTryAgain: '网络异常请稍后重试',
    requestError: '请求错误',
    unauthorizedPleaseLogIn: '未授权，请登录',
    accessDenied: '拒绝访问',
    errorRequestAddress: '请求地址出错:',
    requestTimedOut: '请求超时',
    serverInternalError: '服务器内部错误',
    serviceNotImplemented: '服务未实现',
    gatewayError: '网关错误',
    serviceIsNotAvailable: '服务不可用',
    gatewayTimeout: '网关超时',
    httpVersionNotSupported: 'HTTP版本不受支持',
    unknownMistake: '未知错误',
    desperatelyLoading: '拼命加载中'
  },
  en: {
    networkAbnormalityTryAgain: 'Network abnormality, please try again later',
    requestError: 'Request error',
    unauthorizedPleaseLogIn: 'Unauthorized, please log in',
    accessDenied: 'access denied',
    errorRequestAddress: 'Request address error:',
    requestTimedOut: 'Request timed out',
    serverInternalError: 'Server internal error',
    serviceNotImplemented: 'Service not implemented',
    gatewayError: 'Gateway error',
    serviceIsNotAvailable: 'service is not available',
    gatewayTimeout: 'Gateway timeout',
    httpVersionNotSupported: 'HTTP version is not supported',
    unknownMistake: 'unknown mistake',
    desperatelyLoading: 'Desperately loading'
  },
  ja: {
    networkAbnormalityTryAgain: 'ネットワーク異常、しばらくしてからもう一度お試しください',
    requestError: 'リクエストエラー',
    unauthorizedPleaseLogIn: '不正、ログインしてください',
    accessDenied: 'アクセスが拒否されました',
    errorRequestAddress: 'リクエストアドレスエラー:',
    requestTimedOut: 'リクエストはタイムアウトしました',
    serverInternalError: 'サーバー内部エラー',
    serviceNotImplemented: 'サービスは実装されていません',
    gatewayError: 'ゲートウェイエラー',
    serviceIsNotAvailable: 'サービスはご利用いただけません',
    gatewayTimeout: 'ゲートウェイのタイムアウト',
    httpVersionNotSupported: 'HTTPバージョンはサポートされていません',
    unknownMistake: '未知の間違い',
    desperatelyLoading: '必死にロード'
  }
}

export default i18n



// WEBPACK FOOTER //
// ./src/utils/response/i18n.js